// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3mLd5","buttons":"SendReceipts_buttons__I72wk","email":"SendReceipts_email__3iBZ9","bookApptTitle":"SendReceipts_bookApptTitle__PTS1t"};